/**
 * 外置浏览器尽力唤起微信原生「扫一扫」。
 * 非官方文档能力：Android Intent 相对稳；iOS 可能只打开微信首页或被系统拦截。
 * 防死循环：单次调用只赋一次 location，不递归、不定时反复跳。
 *
 * @returns {boolean} 是否已发起唤起（不代表一定进入扫一扫）
 */
export function openWeixinScan () {
  if (typeof window === 'undefined' || !window.location) {
    return false
  }
  const ua = String(navigator.userAgent || '')
  const isAndroid = /Android/i.test(ua)
  try {
    if (isAndroid) {
      // Chrome 等可通过 Intent 落到微信包；失败时系统可能无响应，用户再手动开扫一扫
      window.location.href = 'intent://scanqrcode#Intent;scheme=weixin;package=com.tencent.mm;end'
      return true
    }
    window.location.href = 'weixin://scanqrcode'
    return true
  } catch (e) {
    try {
      window.location.href = 'weixin://scanqrcode'
      return true
    } catch (e2) {
      return false
    }
  }
}

const WX_SCHEME = 'weixin://'
const WX_INTENT = 'intent://#Intent;scheme=weixin;package=com.tencent.mm;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;end'

let openWxBusy = false
let openWxFallbackTimer = 0

function isIosLikeUa () {
  if (typeof navigator === 'undefined') {
    return false
  }
  const ua = navigator.userAgent || ''
  if (/iPhone|iPad|iPod/i.test(ua)) {
    return true
  }
  return navigator.platform === 'MacIntel' && Number(navigator.maxTouchPoints || 0) > 1
}

function clickHrefOnce (url) {
  if (!url || typeof document === 'undefined') {
    return false
  }
  try {
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.rel = 'noopener'
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    if (a.parentNode) {
      a.parentNode.removeChild(a)
    }
    return true
  } catch (e) {
    try {
      window.location.href = url
      return true
    } catch (e2) {
      return false
    }
  }
}

function clearOpenWxFallback () {
  if (openWxFallbackTimer) {
    clearTimeout(openWxFallbackTimer)
    openWxFallbackTimer = 0
  }
}

/**
 * 外置浏览器唤起微信 App（首页，不是扫一扫）。
 * iOS：weixin://；安卓 Chrome 系：Intent；其它安卓壳：先 scheme，仍留在页再补一次 Intent。
 * 防死循环：busy 锁 + 至多一次延时兜底，不递归。
 */
export function openWeixinApp () {
  if (typeof window === 'undefined' || !window.location) {
    return false
  }
  if (openWxBusy) {
    return false
  }
  openWxBusy = true
  setTimeout(() => {
    openWxBusy = false
  }, 2500)

  const ua = String(navigator.userAgent || '')
  if (isIosLikeUa() || !/Android/i.test(ua)) {
    return clickHrefOnce(WX_SCHEME)
  }

  const chromeLike = /Chrome|EdgA|SamsungBrowser|Firefox/i.test(ua)
    && !/UCBrowser|UBrowser|MQQBrowser|QQBrowser|Quark|MicroMessenger|MiuiBrowser|HuaweiBrowser|HeyTapBrowser|VivoBrowser|OPPOBrowser|baiduboxapp|baidubrowser/i.test(ua)
  if (chromeLike) {
    return clickHrefOnce(WX_INTENT)
  }

  clickHrefOnce(WX_SCHEME)
  clearOpenWxFallback()
  const onHide = () => {
    if (document.hidden) {
      clearOpenWxFallback()
      document.removeEventListener('visibilitychange', onHide)
    }
  }
  document.addEventListener('visibilitychange', onHide)
  openWxFallbackTimer = setTimeout(() => {
    document.removeEventListener('visibilitychange', onHide)
    openWxFallbackTimer = 0
    if (document.hidden) {
      return
    }
    clickHrefOnce(WX_INTENT)
  }, 800)
  return true
}
